<template>
<div class="chapter">
<div class="inner_page">
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<h1 class="block_1" id="toc_id_5">The Model </h1>
<p class="block_12" id="calibre_pb_4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?1abfa725